<app-pcbread-crumb [data]="'Administration,BasicData,DrugDistributor'"></app-pcbread-crumb>
<app-pccrud [endPoint]="'DrugDistributor'"></app-pccrud>